import { Userbot } from "../../interfaces"

export interface ClientOption {
  value: string
  label: string
}

/**
 * Опции clientId-Autocomplete: клиенты из GET /userbot/clients
 * ({ value: c.id, label: c.name } — прецедент fieldSpecForm.optionsFor("clients"),
 * без фильтра по isAuthorized — D6) + {{...}}-подсказки голов.
 */
export const clientIdOptions = (
  clients: Userbot.Client[] | undefined,
  headHints: string[],
): ClientOption[] => [
  ...(clients ?? []).map((c) => ({ value: c.id, label: c.name })),
  ...headHints.map((h) => ({ value: h, label: h })),
]

/** Метка значения clientId: имя клиента из списка; иначе само значение (uuid или {{...}}). */
export const clientValueLabel = (
  value: string,
  options: ClientOption[],
): string => options.find((o) => o.value === value)?.label ?? value
